// extracted by mini-css-extract-plugin
export default {"container":"TeamTemplate_container__Ev0ik","decoration":"TeamTemplate_decoration__HZ8KT"};